module.exports = require('./helpers/bundle-url').getBundleURL('dswdd') + "resources/favicons/favicon.png";